var buttonStyles = {"button":"Button-module_button__3VGaT","primary":"Button-module_primary__2jInt","secondary":"Button-module_secondary__fQhgj","disabled":"Button-module_disabled__3X2Zy","onLoading":"Button-module_onLoading__1SlY8","sm":"Button-module_sm__lk94L","md":"Button-module_md__2xC06","lg":"Button-module_lg__27toc","fullWidth":"Button-module_fullWidth__3KuwF"};

export { buttonStyles as default };
//# sourceMappingURL=Button.module.css.js.map
